<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
    <div class="home-content common-home-content max-640">
        <div class="main-container ice_bg" v-show="show">
            <div class="operation-main clearfix">
                <div class="fl switch" @click="diseaseShow()">
                    <div class="switch-box">{{switch_name}}</div>
                </div>
            </div>
            <div class="max-280">
                <div class="jingpan pr">
                    <div class="jingpan-bg jingpan_bg" :style="jingpan_styles"></div>
                    <div class="jingpan-text"></div>
                    <div class="archor" :style="archor_styles"></div>
                    <div class="currnet-time current_time">{{now_time}}</div>
                </div>
            </div>
            <div class="pl5 pr5">
                <div class="jing-info-main clearfix">
                    <div class="jing-time jing_time fl" @click="feastpageLink()">
                        <div class="date">
                            <p class="p1">{{now_date.day}}</p>
                            <p class="p2">{{now_date.year}}/{{now_date.month}}</p>
                        </div>
                        <div class="tc">
                            <div class="calendar clearfix">
                                <p class="p3 fl">{{festival.year}}</p>
                                <p class="p4 fl">{{festival.lunar_day}}</p>
                                <p class="p5 fl">{{festival.jieqi}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="jing-intro fr">
                        <div class="intro-mt clearfix info_mt" @click="imgShow()">
                            <div class="fl">
                            <p class="p6">{{cur_intro.jing_name}}</p>
                            <p class="p7">{{cur_intro.name}}</p>
                            <p class="p8">{{cur_intro.time_range}}</p>
                        </div>
                        <div class="fr">
                            <img :src="cur_intro.jing_img" class="intro-img intro_img" alt="">
                        </div>
                        </div>
                        <div class="intro-mc" @click="meridianpageLink()">
                            <p class="p9">{{yangsheng_text}}</p>
                            <span class="more">查看更多</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="disease-container ice_bg" v-show="disease_show">
            <div class="max-640">
                <ul class="disease_list disease-list clearfix">
                    <li class="fl disease-item"
                        v-for="(disease, index) in diseases"
                        :key="index"
                        @click="selectDisease(disease)"
                    >
                        <div class="disease">
                            <div class="border">
                                <span class="ib ellipsis">{{disease}}</span>
                                <div class="b_c_l">
                                    <span class="b_b_l"></span> 
                                    <span class="b_i_l"></span>
                                </div>
                                <div class="b_c_r">
                                    <span class="b_b_r"></span>
                                    <span class="b_i_r"></span>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="back-main">
                    <div class="back-jing back_jing"
                        @click="diseaseShow()"
                    >返回</div>
                </div>
            </div>
        </div>
        <div class="img-content" v-show="img_show" @click="imgShow()">
            <img :src="cur_intro.jing_img" alt="">
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      locData: {},
      show: false,
      disease_show: false,
      img_show: false,
      switch_name: '切换疾病',
      now_date: {},
      festival: {},
      cur_intro: {},
      jing_diseases: [],
      diseases: [],
      now_time: '12:00:00',
      archor_styles: '',
      jingpan_styles: '',
      yangsheng_text: ''
    };
  },
  created() {
    this.loadinti();
    window.appBack = ()=> this.pageback();
  },
  methods: {
    getDate(){
        var currentDate = {},
            date = new Date();
        currentDate['year'] = date.getFullYear() < 10 ? '0'+date.getFullYear() : date.getFullYear();
        currentDate['month'] = (date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1;
        currentDate['day'] = date.getDate() < 10 ? '0'+date.getDate() : date.getDate();

        return currentDate;
    },
    timeFormat(arr){
       if(arr[0] < 12 && 12 < arr[1]){
            return '上午'+arr[0]+'点至下午'+arr[1]+'点';
       }else if(arr[0] < 24 && arr[1] < 3){
            return '下午'+arr[0]+'点至上午'+arr[1]+'点';
       }else if(arr[0] < 12 && arr[1] < 12){
            return '上午'+arr[0]+'点至'+arr[1]+'点';
       }else{
            return '下午'+arr[0]+'点至'+arr[1]+'点';
       }

    },
    getTime(){
        var date = new Date();
        var hour = date.getHours();
        var min = date.getMinutes();
        var sec = date.getSeconds();
        hour = hour < 10 ? '0' + hour : hour;
        min = min < 10 ? '0' + min : min;
        sec = sec < 10 ? '0' + sec : sec;
        return hour+':'+min+':'+sec;
    },
    getArchor(){
        var date = new Date();
        var hour = date.getHours();
        var min = date.getMinutes();
        var rads = (hour*60+min)/4;
        var style = {
            'transform':'rotate('+rads+'deg)',
            '-webkit-transform':'rotate('+rads+'deg)',
            '-moz-transform':'rotate('+rads+'deg)',
            '-o-transform':'rotate('+rads+'deg)'
        }
        return style;
    },
    loadinti(){
        var that = this;
        that.now_date = that.getDate();
        that.$api.get("/health/getlunardata", "").then(function(res) {
            that.locData = res.data.data;
            that.festival = {'jieqi':that.locData.jieqi, 'year':that.locData.year, 'lunar_day':that.locData.lunar_day};
            that.diseases = that.locData.diseases;

            that.cur_intro = {
                'jing_name':that.locData.jing_data.jing_name, 
                'name':that.locData.jing_data.name,
                'jing_img':that.locData.jing_data.jing_image,
                'time_range':that.timeFormat(that.locData.jing_data.time_range)
            }
            
            for(var k in that.locData.jing_data.disease){
                that.jing_diseases.push(k);
            }

            var rads = (that.locData.jing_data.time_range[0]+that.locData.jing_data.time_range[1])*7.5;
            that.jingpan_styles = {
                'transform':'rotate('+rads+'deg)',
                '-webkit-transform':'rotate('+rads+'deg)',
                '-moz-transform':'rotate('+rads+'deg)',
                '-o-transform':'rotate('+rads+'deg)'
            };

            var exist_disease = that.$utils.getUrlKey("d");
            if(exist_disease){
                if(that.jing_diseases.indexOf(exist_disease) > -1 && exist_disease != '常规'){
                    that.yangsheng_text = that.locData.jing_data.disease[exist_disease].yang;
                }else{
                    that.yangsheng_text = that.locData.jing_data.disease['常规'].yang;
                }
                that.switch_name = exist_disease;
            }else{
                that.yangsheng_text = that.locData.jing_data.yangsheng;
            }
            that.now_time = that.getTime();
            that.archor_styles = that.getArchor();
            setInterval(function(){
                that.now_time = that.getTime();
            }, 1000);
            that.show = true;
        });
    },
    selectDisease(id){
        if(this.jing_diseases.indexOf(id) > -1 ){
            this.yangsheng_text = this.locData.jing_data.disease[id].yang;
        }else{
            this.yangsheng_text = this.locData.jing_data.disease['常规'].yang;
        }
        this.switch_name = id;
        this.disease_show = false;
    },
    diseaseShow(){
        this.disease_show = !this.disease_show;
    },
    imgShow(){
        this.img_show = !this.img_show;
    },
    feastpageLink() {
        if(this.switch_name == '切换疾病'){
            this.$router.push({ path: "/feastpage"});
        }else{
            this.$router.push({ path: "/feastpage?d=" + this.switch_name});
        }
    },
    meridianpageLink() {
        if(this.switch_name == '切换疾病'){
            this.$router.push({ path: "/meridianpage"});
        }else{
            this.$router.push({ path: "/meridianpage?d=" + this.switch_name});
        }
    },
    pageback(){
        return null;
    }
  }
}
</script>

